export const einsteinProductRecommendationStyles = {
    '.einsteinRecommendations': {
        maxWidth: '1920px',
        overflow: 'hidden',
        '.product-items-inner-block': {
            msOverflowStyle: 'none' /* IE and Edge */,
            scrollbarWidth: 'none' /* Firefox */,
            /* Hide scrollbar for Chrome, Safari and Opera */
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            '.product-tile-block': {
                width: '333px',
                padding: {base: '8px', md: '16px 16px 0'},
                margin: '0 10px',
                backgroundColor: 'secondaryPageBgColor',
                borderRadius: '8px'
            },
            '.wishlistButton': {
                position: {base: 'static', sm: 'absolute'},
                right: '8px',
                top: '8px'
            }
        },
        '.arrow': {
            padding: '16px 8px',
            position: 'absolute',
            '&.left-arrow': {
                borderRadius: '8px 0 0px 8px',
                left: '-55px'
            },
            '&.right-arrow': {
                borderRadius: '8px 0 0 8px',
                transform: 'rotateY(180deg)',
                right: '-55px'
            }
        },
        '.recently-viewed-block': {
            padding: '0',
            margin: '0 10px',
            backgroundColor: 'white',
            borderRadius: '8px'
        }
    }
}
